import {MenuItem} from './menu.model';
import {Acl} from "../../core/models/acl";

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.MENU.TEXT',
        isTitle: true
    },
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARD.TEXT',
        icon: 'ri-pie-chart-line',
        link: ''
    },
    {
        id: 10,
        label: 'MENUITEMS.INSTRUCCION_EMBARQUE.TEXT',
        icon: 'ri-draft-line',
        link: '/instruccion-embarque',
        viewOnlyQA: true
    },
    {
        id: 3,
        label: 'MENUITEMS.OPERACIONES.TEXT',
        icon: 'ri-ship-2-line',
        subItems: [
            {
                id: 4,
                label: 'MENUITEMS.OPERACIONES.LIST.TRACKING',
                link: '/trazabilidad/operaciones',
                parentId: 3,
                acl: Acl.OPERACIONES
            }/*,
            {
                id: 9,
                label: 'MENUITEMS.OPERACIONES.LIST.CITAS',
                link: '/operaciones/citas',
                parentId: 9,
                acl: Acl.CITAS,
            }*/

        ]
    },
    {
        id: 6,
        label: 'MENUITEMS.MATRICES.TEXT',
        icon: 'ri-archive-drawer-line',
        subItems: [
            {
                id: 5,
                label: 'MENUITEMS.TRAZABILIDAD.LIST.DOCUMENTACION',
                link: '/control/documentacion',
                parentId: 3,
                acl: Acl.DOCUMENTACION
            }
        ]
    },
    {
        id: 16,
        label: 'MENUITEMS.MATRICES.LIST.MATRIZ',
        icon: 'ri-book-2-line',
        link: '/control/matriz',
        acl: Acl.CONTROL_DOCUMENTARIO
    },
    {
        id: 10,
        label: 'MENUITEMS.REPORTS.TEXT',
        icon: 'ri-file-list-3-line',
        subItems: [
            {
                id: 8,
                label: 'MENUITEMS.MATRICES.LIST.PLAZOS',
                link: '/control/plazos',
                parentId: 10,
                acl: Acl.PLAZOS
            },
            {
                id: 10,
                label: 'MENUITEMS.OPERACIONES.LIST.CANALES',
                link: '/operaciones/canales',
                parentId: 9,
                acl: Acl.CANALES
            },
            {
                id: 10,
                label: 'MENUITEMS.REPORTS.LIST.DATOS_FINALES',
                link: '/reports/datosfinales',
                parentId: 10,
                acl: Acl.DATOS_FINALES
            },
            {
                id: 12,
                label: 'MENUITEMS.REPORTS.LIST.AEREO_TERRESTRE',
                link: '/reports/aereoterrestre',
                parentId: 10,
                acl: Acl.DATOS_FINALES
            },
            {
                id: 11,
                label: 'MENUITEMS.REPORTS.LIST.STATUS_DOCUMENTARIO',
                link: '/reports/documentario',
                parentId: 10,
                acl: Acl.STATUS_DOCUMENTARIO
            }
        ]
    },
    {
        id: 15,
        label: 'MENUITEMS.GRAFICO.TEXT',
        icon: 'ri-pie-chart-line',
        subItems: [
            {
                id: 16,
                label: 'MENUITEMS.GRAFICO.LIST.KPI_DAM',
                link: '/grafico/dam',
                parentId: 15,
            }
        ]
    },
    {
        id: 9,
        label: 'MENUITEMS.GESTION.TEXT',
        icon: 'ri-settings-2-line',
        subItems: [
            {
                id: 10,
                label: 'MENUITEMS.GESTION.LIST.CORREOS',
                link: '/gestion/correos',
                parentId: 9,
                acl: Acl.GESTION
            },
            {
                id: 100,
                label: 'MENUITEMS.GESTION.LIST.CLIENTES',
                link: '/gestion/clientes',
                parentId: 9,
                acl: Acl.GESTION
            }
        ]
    }


];
